/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Question_1Inputs */

const en_help_center__account_n_technical__question_1 = /** @type {(inputs: Help_Center__Account_N_Technical__Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I change my email address or account details?`)
};

/**
* | output |
* | --- |
* | "Can I change my email address or account details?" |
*
* @param {Help_Center__Account_N_Technical__Question_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__question_1 = /** @type {((inputs?: Help_Center__Account_N_Technical__Question_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Question_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__question_1(inputs)
});